<template>
    <div class="kv-site kv-main">
        <content class="kv-page">

          <!-- menu -->
          <section class="background-id_3m16 lahuni82" style=" position:relative;">
              <div class="position-relative kv-content">
                  <div class="header-container no-cover ">
                      <div class="kv-fixed-header navigation-position  menu-top" data-kv-scroll-offset="32">
                          <div class="container-fluid navigation">
                              <header data-dynamic-container-element="true">
                                  <div class="kv-background " style=" background-color: rgb(255,255,255);">
                                      <div class="kv-background-inner " data-image="background-image: url('images/menu.png');" style="background-image: url('images/menu.png');background-color: rgb(255,255,255);opacity: 0.5;"></div>
                                  </div>

                                  <div class="logo" data-dynamic-navigation-element="logo">
                                  </div>
                                  <MenuPrincipal />
                              </header>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <!-- titulo -->
          <section id="subMenu" class="background-id_0 tehulu61 rifijo58" style=" position:relative;">
            <div class="container titles">
              <div class="row">
                <div class="section-text col-12 offset-lg-1">
                  <h2 data-type="text" class="section-title caption-title section-title--sm">
                    Nossa Equipe
                  </h2>
                  <p class="section-subtitle section-subtitle--sm" data-type="text">
                    Conheça melhor os profissionais que irão atendê-lo:
                  </p>
                </div>
              </div>
            </div>
          </section>

            <section class="background-id_0 tehulu61 rifijo58" style=" position:relative;">

                <div class="position-relative kv-content">
                    <div class="section align-left ">
                        <div class="container items">
                            <div class="row position">
                                <div class="col-12 landscape">
                                    <div>
                                        <div class="row" data-type="list">
                                            <div class="kv-control-placeholder kv-_list" data-kv-control="0"></div>
                                            <div class="col-12 align-left">
                                                <div class="row item default-card drop-shadow-md item-left">
                                                    <div class="col-4 image-container aspect-landscape">
                                                        <div data-type="image" data-property="image" class="item-img kv-gallery content-image" style="background-position-y:9.330652488792504%;background-image: url('images/elizangela.jpg');"></div>
                                                    </div>
                                                    <div class="col content-text">
                                                        <div class="title--sm" data-type="text">ELIZANGELA DE OLIVEIRA<br></div>
                                                        <p class="subtitle body--sm" data-type="text">
                                                            Advogada com registro na OAB/RS sob n. 46.611, graduada em Direito pela Universidade Luterana do Brasil (1997) e Especialista em Direito do Trabalho pela Unisinos - 2005.<br ><br >
                                                            Pós-graduação em direito digital e proteção de dados pela EBRADI - Escola Brasileira de Direito.
                                                            Administradora Judicial certificada pelo 1º Curso de Administrator TMA Brasil – Porto Alegre/RS, 2019 e pelo curso de Capacitação à Advocacia em Recuperação Judicial de Empresas (noções práticas), promovido pela OAB/RS- ESA – Porto Alegre, 2015.<br ><br >
                                                            Participou da Gestão de Crise Empresarial, Recuperação Judicial e Falências, promovido pela ESPM em Porto Alegre/RS – 2015; do Congresso Internacional de 10 anos de Vigência da Lei de Recuperação e Falências, promovido pelo INRE em São Paulo/SP – 2015; VII Congresso Internacional de Direito Empresarial- A crise empresarial e seus desafios legais (2016) e Curso de Aperfeiçoamento em Recuperação Judicial de Empresas pela ESA (2019). Ainda, ministrou a cadeira de empresarial com ênfase em Recuperação Judicial e Falência na IMED em 2009 - Passo Fundo/RS.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="kv-control-placeholder kv-_list" data-kv-control="1"></div>
                                            <div class="col-12 align-left">
                                                <div class="row item default-card drop-shadow-md item-right">
                                                    <div class="col content-text">
                                                        <div class="title--sm" data-type="text">MARTA FANTINELLI<br></div>
                                                        <p class="subtitle body--sm" data-type="text">

                                                            Advogada com registro na OAB/RS sob n. 97.334.<br>
                                                            Graduada em Direito pela Faculdade Anhanguera de Passo Fundo/RS (2014). 
                                                            Participou do grupo de estudos Direito e Literatura na Faculdade Anhanguera de Passo Fundo.<br>

                                                            Pós-graduada em Direito Civil com ênfase em Direito de Família pela Anhanguera (2016);<br><br>

                                                            Curso de Aperfeiçoamento em Procedimentos Especiais Cíveis no CPC pela ESA (2020);
                                                            Curso de Aperfeiçoamento em Recuperação Judicial de Empresas pela ESA (2020).<br><br>
                                                            Participou do evento Recuperação Extrajudicial promovido pela OAB/RS (2020).

                                                        </p>
                                                    </div>
                                                    <div class="col-4 image-container aspect-landscape">
                                                        <div data-type="image" data-property="image" class="item-img kv-gallery content-image " style="background-position-x:50%;background-image: url('images/marta.jpg');"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="kv-control-placeholder kv-_list" data-kv-control="2"></div>
                                            <div class="col-12 align-left">
                                                <div class="row item default-card drop-shadow-md item-left">
                                                    <div class="col-4 image-container aspect-landscape">
                                                        <div data-type="image" data-property="image" class="item-img kv-gallery content-image " style="background-position-x:50%;background-image: url('images/alvaro.jpg');"></div>
                                                    </div>
                                                    <div class="col content-text">
                                                        <div class="title--sm" data-type="text">ALVARO CESAR ALVES DE CARVALHO</div>
                                                        <p class="subtitle body--sm" data-type="text">
                                                            Advogado com registro OAB/RS sob o n. 104.232. <br>
                                                            Graduado em Direito pela Faculdade – IMED de Passo Fundo/RS (2016).<br>
                                                            Pós-graduado em Direito do Trabalho e Processo do Trabalho pela UPF-RS (2018).<br>
                                                            Curso de liquidação de sentenças e cálculos trabalhista (2014).
                                                       </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="kv-control-placeholder kv-_list" data-kv-control="1"></div>
                                            <div class="col-12 align-left">
                                                <div class="row item default-card drop-shadow-md item-right">
                                                    <div class="col content-text">
                                                        <div class="title--sm" data-type="text">EVA MOTTA<br></div>
                                                        <p class="subtitle body--sm" data-type="text">
                                                            Graduada em Ciências Contábeis pela URGS (1974).<br>
                                                            Graduada em Direito pela IMED (2020).<br>
                                                            Especialização em Auditoria Interna pela UFRGS (1976).<br>
                                                            Especialização em Auditoria FIPECAFI-USP (1979).<br>
                                                            Auditora/Inspetora aposentada do BANCO CENTRAL DO BRASIL (01/12/1976 – 29/01/2009).<br>
                                                            Conciliadora do TJRS- CEJUSC POA desde 2016.<br>
                                                            Mediadora do TJRS- CEJUSC POA desde 2018.<br><br>
                                                            Liquidante das empresas em liquidação extrajudicial: Uruguaiana Administradora De Consórcios LTDA, Planalto Administradora De Consórcio LTDA, Administradora Trilho Orero LTDA., Investnorte Corretora de Valores e Cambio LTDA.<br><br>
                                                            Participou do XIV Congresso de Direito Tributário em Gramado (2015); do Congresso Internacional de 10 anos de Vigência da Lei de Recuperação e Falências promovido pelo Instituto Nacional Recuperação Empresarial em São Paulo (2015); do XI Encontro do Mestrado em Ciências Contábeis da UERJ e II Congresso Latino- Americano de Contabilidade de Gestão (2009); do Congresso de Boa Governança no Sistema Financeiro 2007) e do Curso Contabilidade de Grupos de Consórcio em 2005.
                                                        </p>
                                                    </div>
                                                    <div class="col-4 image-container aspect-landscape">
                                                        <div data-type="image" 
                                                            data-property="image" class="item-img kv-gallery content-image " 
                                                            style="background-position-x:50%;background-image: url('images/eva.jpg');"></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="kv-control-placeholder kv-_list" data-kv-control="2"></div>
                                            <div class="col-12 align-left">
                                                <div class="row item default-card drop-shadow-md item-left">
                                                    <div class="col-4 image-container aspect-landscape">
                                                        <div 
                                                            data-type="image" data-property="image" class="item-img kv-gallery content-image " 
                                                            style="background-position-x:50%;background-image: url('images/eduarda.jpg');"></div>
                                                    </div>
                                                    <div class="col content-text">
                                                        <div class="title--sm" data-type="text">EDUARDA APARECIDA DOS SANTOS</div>
                                                        <p class="subtitle body--sm" data-type="text">

                                                            Estagiária. <br>

                                                            Graduanda em Direito pela UPF.<br>

                                                            Integrante do grupo de pesquisa Dimensões de Poder, Gênero e Diversidade.
                                                       </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="background-id_0adjacent qukefe53" style=" position:relative;">

                <div class="position-relative kv-content">
                    <div class="kv-control-placeholder kv-_section" data-kv-control="content"></div>
                    <div class="section section--sm kv-notify-inview align-center">
                        <div class="container">
                            <div class="row v-center direction">
                                <div class="section-text column">

                                </div>
                                <div class="column button-group">
                                    <router-link class="button-lg move-button undefined button-dynamic-buttons kv-button-instant-edit button-primary" 
                                    data-index="0" data-type="button" tabindex="4" data-href="areas-de-atuacao" to="/areas-de-atuacao" data-property="buttons">
                                        <div style="" class="button-has-title">Conheça nossas áreas de atuação<br>
                                            <div data-editable="button" data-prop="buttons.0.title" style="display:none;">
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

        </content>
    </div>
</template>

<script>

import MenuPrincipal from '@/components/MenuPrincipal.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Equipe',
    components: {
        MenuPrincipal, Footer
    }
}
</script>